import Button from 'components/ui/Button';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const AttributeSection = ({ attributes, onAddAttribute }) => {
  const { t } = useTranslation();
  const [newAttribute, setNewAttribute] = useState({
    name: { en: '', ar: '' },
    values: []
  });

  const [newValue, setNewValue] = useState({ en: '', ar: '' });

  const handleAddValue = () => {
    if (newValue.en && newValue.ar) {
      setNewAttribute(prev => ({
        ...prev,
        values: [...prev.values, { ...newValue }]
      }));
      setNewValue({ en: '', ar: '' });
    }
  };

  const handleAddAttribute = () => {
    if (newAttribute.name.en && newAttribute.name.ar && newAttribute.values.length > 0) {
      onAddAttribute(newAttribute);
      setNewAttribute({
        name: { en: '', ar: '' },
        values: []
      });
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <h2 className="text-xl font-semibold mb-4">{t('attributes_title')}</h2>
      
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">{t('attribute_name_en')}</label>
            <input
              type="text"
              value={newAttribute.name.en}
              onChange={(e) => setNewAttribute(prev => ({
                ...prev,
                name: { ...prev.name, en: e.target.value }
              }))}
              className="w-full px-3 py-2 border rounded"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-1">{t('attribute_name_ar')}</label>
            <input
              type="text"
              value={newAttribute.name.ar}
              onChange={(e) => setNewAttribute(prev => ({
                ...prev,
                name: { ...prev.name, ar: e.target.value }
              }))}
              className="w-full px-3 py-2 border rounded"
            />
          </div>
        </div>

        <div className="border-t pt-4 space-y-4">
          <h3 className="font-medium">{t('attribute_values_title')}</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">{t('value_en')}</label>
              <input
                type="text"
                value={newValue.en}
                onChange={(e) => setNewValue(prev => ({ ...prev, en: e.target.value }))}
                className="w-full px-3 py-2 border rounded"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-1">{t('value_ar')}</label>
              <input
                type="text"
                value={newValue.ar}
                onChange={(e) => setNewValue(prev => ({ ...prev, ar: e.target.value }))}
                className="w-full px-3 py-2 border rounded"
              />
            </div>
          </div>
          
          <button
            type="button"
            onClick={handleAddValue}
            className="px-3 py-1 bg-gray-200 rounded text-sm hover:bg-gray-300"
          >
            {t('add_value')}
          </button>
          
          <div className="space-y-2">
            {newAttribute.values.map((value, index) => (
              <div key={index} className="bg-gray-100 p-2 rounded flex justify-between">
                <div>
                  <span className="font-medium">{value.en}</span> - {value.ar}
                </div>
                <button
                  type="button"
                  onClick={() => setNewAttribute(prev => ({
                    ...prev,
                    values: prev.values.filter((_, i) => i !== index)
                  }))}
                  className="text-red-500 text-sm"
                >
                  {t('remove')}
                </button>
              </div>
            ))}
          </div>
        </div>
        
        <Button
          type="button"
          onClick={handleAddAttribute}
      //    className="mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          disabled={!newAttribute.name.en || !newAttribute.name.ar || newAttribute.values.length === 0}
        >
          {t('add_attribute')}
        </Button>
      </div>

      {attributes.length > 0 && (
        <div className="mt-6">
          <h3 className="font-medium mb-2">{t('added_attributes_title')}</h3>
          <div className="space-y-3">
            {attributes.map((attr, attrIndex) => (
              <div key={attrIndex} className="border p-3 rounded">
                <div className="font-medium">
                  {attr.name.en} / {attr.name.ar}
                </div>
                <div className="mt-2 space-y-1">
                  {attr.values.map((value, valueIndex) => (
                    <div key={valueIndex} className="text-sm text-gray-600">
                      {value.en} / {value.ar}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AttributeSection;
